/**
 * Common helper functions
 */
import LocalStorage from "./LocalStorage";
import storageType from "../constants/storageType";
const language = LocalStorage.getValue(storageType.LANGUAGE) || 'en';

const Helper = {
    // Set user language
    setLang: (eng, tha, rus) => {
        if (language === 'th') {
            return tha;
        } else if (language === 'ru') {
            return rus;
        } else {
            return eng;
        }
    },
    // Generate random string
    randomString: function (length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    },
    // Generate new unique id
    generateUniqueID: function () {
        const milliSeconds = Date.now();
        const secondStr = String(milliSeconds).slice(-10);
        return Number(secondStr);
    },
    // Get current data & time
    curDateTime: function () {
        let obj = new Date();

        // Current day
        // Adjust 0 before single digit date
        let day = ("0" + obj.getDate()).slice(-2);

        // Current month
        let month = ("0" + (obj.getMonth() + 1)).slice(-2);

        // Current year
        let year = obj.getFullYear();

        // current hours
        let hours = ("0" + obj.getHours()).slice(-2);

        // current minutes
        let minutes = ("0" + obj.getMinutes()).slice(-2);

        // current seconds
        let seconds = ("0" + obj.getSeconds()).slice(-2);

        return (year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds);
    },
};

export default Helper;